<template>
    <div>
      <div v-if="loading">
        <p>Cargando..</p>
      </div>
      <div class="mb-8 flex justify-start max-w-3xl">
        <h1 class="font-bold text-3xl">
          <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('applicationbuy')">Regresar</inertia-link>
          <span class="text-indigo-400 font-medium">/</span>
          Generar Pago
        </h1>
       
      </div>
      <div class="flex flex-wrap">
      <div class="w-full">
        <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
              Datos Solicitud
            </a>
          </li>
        </ul>
        <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          
          <div class="px-4 py-5 flex-auto">
            <div class="tab-content tab-space">
              <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
                <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                  <div class="container pb-8 pr-6 w-full lg:w-3/6">
              <label class="form-label" >Bancos:</label>
              <v-select v-model="form.banco_id" :options="bancoss" value="id" label="cuenta"></v-select>
              </div>
              <div class="container pb-8 pr-6 w-full lg:w-3/6">
              <label class="form-label" >Gastos:</label>
              <v-select v-model="form.gasto_id" :options="gastoss" value="id" label="detalle"></v-select>
              </div>   
                <text-input v-model="form.total" :error="form.errors.total" :req="form.total" class="pb-8 pr-6 w-full lg:w-2/6" label="V. Total" required/>         
                <text-input v-model="form.saldo" :error="form.errors.saldo" class="pb-8 pr-6 w-full lg:w-2/6" label="Saldo" disabled/>         

                <div class="container pb-8 pr-6 w-full lg:w-2/6">
              <label class="form-label" >Fecha </label>
            <date-picker v-model="form.fecha" lang="es" ></date-picker>
            </div>
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Pago</loading-button>
          </div>
        </form>
              </div>
              <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
              </div>
              <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </div>
    <preloader />
    </div>
    
  </template>
  
  <script>
  import Layout from '@/Shared/LayoutMenu'
  import FileInput from '@/Shared/FileInput'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import TextareaInput from '@/Shared/TextareaInput'
  import TextInput from '@/Shared/TextInput'
  
  export default {
    metaInfo: { title: 'Generar pago' },
    components: {
      FileInput,
      LoadingButton,
      SelectInput,
      TextInput,
      vSelect,
      DatePicker,
      TextareaInput,
    },
    layout: Layout,
    props: {
      application: Object,
      gastos: Array,
      bancos: Array,

    },
    remember: 'form',
    data() {
      return {
        openTab: 1,
        loading: true,
        bancoss: this.bancos,
        gastoss: this.gastos,
        form: this.$inertia.form({
          id: this.application.id,
          banco_id: null,
          gasto_id: null,
          total: this.application.total_pagar,
          saldo: this.application.saldo,
          fecha: null,
         
        }),
      }
    },
    async mounted(){
      await this.users
      this.loading=false
    },
    methods: {
      toggleTabs: function(tabNumber){
        this.openTab = tabNumber
      },
      store() {
        
        this.form.post('/applicationbuyPagos')
      },
     
    },
  }
  </script>